// SearchBar functional component
import { useState } from 'react';
import styled from 'styled-components';
import { X } from 'lucide-react';
import { colors } from '@annote/core/styles';
import { TextInput } from './TextInput'; // DAVE NOTE 1/6/24 this very generic textinput is really overkill here.
// Let's just simply style the search input here.
// I'd also like to move away from controlled text inputs.  We should follow the style setup in takeaways.tsx

type SearchBarProps = {
  onSearch: (searchTerm: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isSubtle?: boolean;
};

const Wrapper = styled.div`
  position: relative;
`;

const StyledIcon = styled(X)<{ $isVisible: boolean }>`
  position: absolute;
  right: 6px;
  top: 10px;
  color: ${colors.icon.placeholder};
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
`;

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, onFocus, onBlur, isSubtle }) => {
  const [value, setValue] = useState<string>('');
  const [isHovering, setIsHovering] = useState(false);

  const handleChange = (_id: string, newValue: string): void => {
    setValue(newValue);
    onSearch(newValue);
  };

  const handleFocus = (): void => {
    if (onFocus) {
      onFocus();
    }
  };

  const handleBlur = (): void => {
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <Wrapper onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      <TextInput
        id="searchbar"
        onChange={handleChange}
        outsideValue={value}
        iconOption="search"
        iconSize={18}
        onFocus={handleFocus}
        onBlur={handleBlur}
        isSubtle={isSubtle}
      />
      <StyledIcon
        size={18}
        $isVisible={isHovering}
        onClick={() => {
          setValue('');
          onSearch('');
        }}
      />
    </Wrapper>
  );
};

export default SearchBar;
